export default __webpack_public_path__ + "static/media/hero-logo.4829d9aa.webp";